var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "card" }, [
    _c(
      "div",
      { staticClass: "card-body" },
      [
        _vm._m(0),
        _vm._v(" "),
        !_vm.loading
          ? _c("FullCalendar", {
              ref: "FullCalendar",
              attrs: { options: _vm.calendarOptions }
            })
          : _vm._e()
      ],
      1
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row mb-3" }, [
      _c("div", { staticClass: "col d-md-block d-none" }),
      _vm._v(" "),
      _c("div", { staticClass: "col-12 col-md-auto" }, [
        _c("span", { staticClass: "dot dot-secondary" }),
        _vm._v(" Geboekte tafelsessies\n      ")
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-12 col-md-auto" }, [
        _c("span", { staticClass: "dot dot-success" }),
        _vm._v(" Beschikbaar\n      ")
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// /home/dev/tafelgasten.outlawz.dev/web/app/themes/expert/node_modules/vue-loader/lib/loaders/templateLoader.js?{}!/home/dev/tafelgasten.outlawz.dev/web/app/themes/expert/node_modules/vue-loader/lib?{}!./scripts/vue/Agenda/Calendar.vue?vue&type=template&id=b7f29306&
// module id = 397
// module chunks = 0